module.exports = __webpack_public_path__ + "img/no-preview-available-dark.f753f8e7.jpg";